import { Observable } from "rxjs";
import { get, post, put } from "@utils/axios";
import { isEmpty } from "lodash";

import { formatFilterDataForApi } from "@components/filters/colFilters";
import sessionService from "./session.service";
import { localToUTCFormatDate } from "@utils/helpers";
import { CURRENT_ITEM } from "@components/reminder/constants";

class MemberService {
  private memberList: any[] = [];
  private currentMember: any = {};
  private singleMember: boolean = true;
  // private _subject: BehaviorSubject<any> = new BehaviorSubject({curretMember: {}, members: []});

  set setCurrentMember(member: any) {
    this.currentMember = member;
  }

  get getCurrentMember() {
    return this.currentMember;
  }

  set setMemberList(memberList: any) {
    this.memberList = memberList;
  }

  get getMemberList() {
    return this.memberList;
  }

  set setsingleMember(singleMember: boolean) {
    this.singleMember = singleMember;
  }

  get getsingleMember() {
    return this.singleMember;
  }

  private base: string = `${sessionService.getClient()?.appServiceUrl}/patient`;

  members(
    page: number,
    limit: number,
    sortBy?: string,
    sortType?: string,
    searchOn?: any[],
    reminderStartDate?: string,
    reminderEndDate?: string,
    adtGetMembersMapping?: string,
    filterBody?: any,
    patientIdList?: String[],
    patientIDsFromPopInst?: String[]
  ): Observable<any> {
    let param = `page=${page - 1}&limit=${limit}`;
    if (!(sortBy === "priority" && sortType === "ASC")) {
      param = param + (sortBy && sortType ? `&sortBy=${sortBy}&sortType=${sortType}` : "");
    }
    param =
      param + (reminderStartDate && reminderEndDate ? `&reminderStartDate=${localToUTCFormatDate(reminderStartDate)} &reminderEndDate=${localToUTCFormatDate(reminderEndDate + " 23:59:59")}` : "");

    let body = undefined;
    if (filterBody) {
      const filters = formatFilterDataForApi(filterBody);
      body = {
        filters: filters,
        patientIDs: patientIDsFromPopInst,
      };
    }
    if (searchOn) {
      body = {
        ...body,
        searchOn: searchOn,
      };
    }
    if (!isEmpty(patientIdList)) {
      body = {
        ...body,
        patientIDs: patientIdList,
      };
    }
    if (adtGetMembersMapping) {
      body = {
        ...body,
        adtValue: adtGetMembersMapping,
      };
    }

    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/getMembers?${param}`, body);
  }

  memberDetails(param: string): Observable<any> {
    let body = {};
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/getMemberDetails${param}`, body);
  }

  membersByIds(patientIDs: string[], page: number = 1, limit: number = patientIDs.length): Observable<any> {
    let param = `page=${page - 1}&limit=${limit}`;

    let body = {
      patientIDs: patientIDs,
    };

    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/getMembers?${param}`, body);
  }

  addNotes(patientIds: any[], description: any, noteType: any, isBookmarked?: boolean, recipientType?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/note/create`, {
      patientIds: patientIds,
      description: description,
      noteType: noteType,
      isBookmarked: isBookmarked,
      recipientType: recipientType,
    });
  }

  //For uploadig Files
  uploadFile(data: any, config: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/upload`, data, config);
  }

  sendEmail(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/upload/email-test`);
  }

  editNotes(noteId: any, patientId: any, description: any, isBookmarked?: boolean, recipientType?: any, prevBookmarkStatus?: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/note/edit`, {
      noteId: noteId,
      patientId: patientId,
      description: description,
      isBookmarked: isBookmarked,
      recipientType: recipientType,
      prevBookmarkStatus: prevBookmarkStatus,
    });
  }

  //For now it is not created
  deleteNotes(noteId: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/note/delete`, { noteId: noteId });
  }

  bookmarkNotes(noteId: any, bookmark: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/note/bookmark`, { noteId: noteId, bookmark: bookmark });
  }

  addReminder(patientId: any, from: any, to: any, description: any, recurrence: any, reminderType?: any, patientName?: any , reminderTitle ?: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/reminder/create`, {
      patientId: patientId,
      reminderStartDate: from,
      reminderEndDate: to,
      reminder: description,
      reminderType: reminderType?.reminderType,
      patientName: patientName,
      recurrence: recurrence,
      reminderTitle : reminderTitle
    });
  }

  editReminder(reminder: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/edit`, { ...reminder });
  }

  deleteReminder(reminderId: any , parentReminderId ?: string , reminderStartDate ?: string , operationRange : string = CURRENT_ITEM): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/delete`, { reminderId ,parentReminderId, reminderStartDate , operationRange});
  }

  deleteAllReminder(patientId: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/deletePatientReminders?patientID=${patientId}`);
  }
  // incoming by someone from red baton team
  downloadAllMembers(
    columns?: any,
    reminderStartDate?: any,
    reminderEndDate?: any,
    sortData?: any,
    searchOn?: any,
    filters?: any,
    adtState?: string,
    patientListForFilter?: any[],
    columnsType?: string
  ): Observable<any> {
    const { sortColumn: sortBy, sortOrder: sortType } = sortData;
    let param = "";
    if (!(sortBy === "priority" && sortType === "ASC")) {
      param = param + (sortBy && sortType ? `&sortBy=${sortBy}&sortType=${sortType}` : "");
    }
    param =
      param + (reminderStartDate && reminderEndDate ? `&reminderStartDate=${localToUTCFormatDate(reminderStartDate)}&reminderEndDate=${localToUTCFormatDate(reminderEndDate + " 23:59:59")}` : "");
    let parameters = param === "" ? param : `?${param}`;
    const filterData = formatFilterDataForApi(filters);
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/v2/download-all-members${parameters}`, {
      columns: columns,
      patientIDs: patientListForFilter,
      columnsType,
      ...(searchOn && { searchOn: searchOn }),
      filters: filterData,
      ...(adtState && { adtValue: adtState }),
    });
  }

  updateStatus(patientId: any, caseStatusReasonTxt: any, actionModule: any, actionTab: any, actionCard: any, actionLocation: any, actionDescription: any, caseStatus?: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/update-status`, {
      patientId,
      caseStatusReasonTxt,
      actionModule,
      actionTab,
      actionCard,
      actionLocation,
      actionDescription,
      caseStatus,
    });
  }

  getCaseStatus(patientId: any): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/patient-case-status?memberId=${patientId}`);
  }
  updateColumns(columns: any[], adtStatePageName: string): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/column-preference?pageName=${adtStatePageName}`, { columns: columns });
  }

  getMasterData(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getMasterData`);
  }

  /////service for Admission and discharge keyInsight
  getMasterDataForAdmissionAndDischarge(startDate: string, endDate: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getAdmissionAndDischarge`, { startDate: startDate, endDate: endDate });
  }

  getMasterDataForCaseLoad(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/getCaseLoad`);
  }

  fetchAllNotifications(page?: number, filters?: any): Observable<any> {
    const param = `?page=${page || 1}&limit=${process.env.REACT_APP_FETCH_NOTIFICATION_LIMIT || 30}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/notifications/all${param}`, { filters });
  }

  markAllNotificationsAsRead(): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/notifications?notificationID=all`, {});
  }

  updateAlert(alertId: any, id: any = null): Observable<any> {
    let param = `alertsID=${alertId}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/alerts?${param}&patientID=${id}`);
  }

  getAllAlerts(isAllCM: any, memberId?: any, page?: number, filters?: any): Observable<any> {
    let param = `isAllCM=${isAllCM}`;
    if (memberId) {
      param = param + `&memberId=${memberId}`;
    }
    // if (page) {
    //   param = param + `&page=${(page || 1)}&limit=${process.env.REACT_APP_FETCH_NOTIFICATION_LIMIT || 10}`;
    // }
    if (filters?.searchValue || filters?.filterStartDate || filters?.filterEndDate) {
      return post(`${sessionService.getClient()?.appServiceUrl}/patient/alerts/getAlerts?${param}&page=${page || 1}&limit=${process.env.REACT_APP_FETCH_NOTIFICATION_LIMIT || 10}`, {
        ...filters,
      });
    } else {
      return post(`${sessionService.getClient()?.appServiceUrl}/patient/alerts/getAlerts?${param}&page=${page || 1}&limit=${process.env.REACT_APP_FETCH_NOTIFICATION_LIMIT || 10}`);
    }
  }

  getReminderData(isAllCM: any, fromDate: any, toDate: any, memberId?: any): Observable<any> {
    let param = `isAllCM=${isAllCM}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/getReminders?${param}`, { fromDate, toDate, memberId });
  }
  
  getReminderStatistics(isAllCM: any, fromDate: any, toDate: any, memberId?: any) {
    let param = `isAllCM=${isAllCM}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/getReminderStatistics?${param}`, { fromDate, toDate, memberId });
  }

  getReminderDates(isAllCM: any, memberId: any, fromDate: any, toDate: any, UTC_TimeZoneOffset: any) {
    let param = `isAllCM=${isAllCM}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/getReminderCount?${param}`, { fromDate, toDate, UTC_TimeZoneOffset, memberId });
  }

  getPastAndFutureReminder(isAllCM: any, memberId: any, page: any = 1, limit: any = 5, fromDate: any, reminderType: any, toDate?: any) {
    let param = `isAllCM=${isAllCM}`;
    param = param + `&page=${page}&limit=${limit}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/reminder/getPastAndFutureReminders?${param}`, { fromDate, reminderType, toDate, memberId });
  }

  getAllNotes(isAllCM: any, memberId?: any): Observable<any> {
    let param = `isAllCM=${isAllCM}`;
    if (memberId) {
      param = param + `&memberId=${memberId}`;
    }
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/notes/fetch-all-notes?${param}`);
  }

  getNotesForPage({isAllCM , memberId , page, filter , isPaginationRequired = true} : any): Observable<any> {
    let param = `isAllCM=${isAllCM}`;

    if(isPaginationRequired) {
      param = param + `&page=${page}&limit=30`;
    }

    return post(`${sessionService.getClient()?.appServiceUrl}/patient/notes/getNotes?${param}`, { filter , isPaginationRequired, memberId});
  }

  getFilters(pageName: any): Observable<any> {
    let param = `pageName=${pageName}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/v2/filters?${param}`);
  }

  getGlobalReminderMembers(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/global-reminder/patients`);
  }

  setMemberListFn(memberList: any): any {
    this.memberList = memberList;
  }

  classificationUpdate(patientId: any, status: Boolean, classificationType: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/classification/update`, { patientId: patientId, status: status, classificationType: classificationType });
  }

  getRefreshData(payload?: string[]): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/data-refresh-status`, { source: payload });
  }

  getColumnsList(adtStatePageName: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=${adtStatePageName}`);
  }

  getReleaseNotes(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/users/release-notes`);
  }

  fetchRegistryProgramStatus(patientId: any, programType?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/care-coordination/registry-program-status`, {
      patientId: +patientId,
      ProgramType: programType,
    });
  }

  fetchMemberListDataRefreshStatus(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/member-list-data-refresh-status`);
  }

  fetchMemberChronics(patientID: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/chronics`, {
      memberId: patientID
    });
  }

  fetchMemberPersonalInfo(patientID: any): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/personal-info?id=${patientID}`);
  }

  updateProgramDecline({ patientId, prgmId, isDeclined }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/updateProgramDecline`, {
      patientId,
      prgmId,
      isDeclined
    })}
  
  fetchGlobalPatientSearchList({ searchText }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getGlobalPatientSearchList`, {
      searchText
    });
  }

  getStructuredForm({ struct_type }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getStructuredForm`, {
      struct_type,
    });
  }

  addGlobalEntry({ struct_type, entryData, patient_id, level }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/addGlobalEntry`, {
      struct_type,
      entryData,
      patient_id,
      level
    });
  }

  getStructuredNotes({ level , patient_id , filters = {} , searchBy = '' , page}: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/getStructuredNotes`, {
      level,
      patient_id,
      filters,
      searchBy,
      page
    });
  }

  getHolidayList(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/holidayList`);
  }

  getMeasuresInfo(patientID: any, selectedYear?: any): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/measures?patientID=${patientID}&selectedYear=${selectedYear}`);
  }

  listCadence(data: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/cadence/list`, data);
  }

  createCadence(data: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/cadence/create`, data);
  }

  updateCadence(data: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/cadence/update`, data);
  }

  touchCadence(data: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/cadence/touch`, data);
  }

  historyCadence(data: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/cadence/history`, data);
  }

}

export default new MemberService();
